import moment from 'moment'

const TaxDataInvoicingValidator = (t) => {
  moment.locale('es')
  let regexs = {
    nameRegex: new RegExp(/^[A-Za-zñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0 .,;:-]* ?()[A-Za-zñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0 .,;:-]* ?()[A-Za-zñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0 .,;:-]*$/),
    rfcRegex: new RegExp(/^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/),
    streetRegex: new RegExp(/^[A-Za-z0-9 áéíóúÁÉÍÓÚÑñ.,;:#-]+$/),
    colonyRegex: new RegExp(/^[A-Za-z0-9 áéíóúÁÉÍÓÚÑñ.,;:#-]+$/),
    townRegex: new RegExp(/^[A-Za-z0-9 áéíóúÁÉÍÓÚñÑ.,;:-]+$/),
    stateRegex: new RegExp(/^[A-Za-z0-9 áéíóúÁÉÍÓÚñÑ.,;:-]+$/),
    zipCodeRegex: new RegExp(/(^\d{5}$)|(^\d{5}-\d{4}$)/),
  }

  let validators = {
    organizationValidator: (value) => {
      if (value && value.length > 0) {
        return (regexs.nameRegex.test(value) ? '' : t('taxDataInvoincingValidator.nameSocial'))
      }
    },
    rfcValidator: (value) => {
      if (value && value.length > 0) {
        return (regexs.rfcRegex.test(value.toUpperCase()) ? '' : t('taxDataInvoincingValidator.errorRFC'))
      }
    },
    streetValidator: (value) => {
      if (value && value.length > 0) {
        return (regexs.streetRegex.test(value) ? '' : t('taxDataInvoincingValidator.errorStreet'))
      }
    },
    colonyValidator: (value) => {
      if (value && value.length > 0) {
        return (regexs.colonyRegex.test(value) ? '' : t('taxDataInvoincingValidator.errorColony'))
      }
    },
    townValidator: (value) => {
      if (value && value.length > 0) {
        return (regexs.townRegex.test(value) ? '' : t('taxDataInvoincingValidator.errorTownship'))
      }
    },
    stateValidator: (value) => {
      if (value && value.length > 0) {
        return (regexs.stateRegex.test(value) ? '' : t('taxDataInvoincingValidator.errorState'))
      }
    },
    zipCodeValidator: (value) => {
      if (value && value.length > 0) {
        return (regexs.zipCodeRegex.test(value) ? '' : t('taxDataInvoincingValidator.errorZipCode'))
      }
    }
  }

  return validators
}

export { TaxDataInvoicingValidator as default }
